import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'next-i18next';
import { useWorkersService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';
import { showToast } from '@restworld/ui-ds-base';
import { useSetAtom } from 'jotai';
import { setWorkerAtom } from '../../global-state.worker-data';

export const useUpdateWorkerPublicShowcaseMutation = (setLocalValue: (val: boolean) => void) => {
  const { t } = useTranslation('user-settings');
  const workerService = useWorkersService();
  const onSetWorkerData = useSetAtom(setWorkerAtom);
  const { user } = useAuth();
  return useMutation({
    onMutate: (enabled: boolean) => {
      setLocalValue(enabled);
    },
    mutationFn: async (enabled: boolean) =>
      (
        await workerService.updateWorker({
          workerId: user?.id,
          params: {
            new_public_showcase_notification_enabled: enabled,
          },
        })
      ).data,
    onSuccess: (data) => {
      onSetWorkerData({ ...data });
    },
    onError: (error, enabled) => {
      showToast(t('error_updating_public_showcase_notification_status'), 'error', {
        autoClose: 3500,
        position: 'top-right',
      });
      setLocalValue(!enabled);
      // eslint-disable-next-line no-console
      console.error('Error updating worker data:', error);
    },
  });
};
